import {AfterViewInit, Component, OnInit} from '@angular/core';
import {TableAction, TableColumn, TableColumnType} from "../../components/table/table.component";
import {CardAction} from "../../components/scotty-card/scotty-card.component";
import {Router} from "@angular/router";
import {Chip} from "../../components/list-view-element/list-view-element.component";
import {Equipment} from "../../models/equipment";
import {EquipmentManagerService} from "../../services/equipment-manager.service";
import {UiManagerService} from "../../services/ui-manager.service";
import {AuthoringManagerService} from "../../services/authoring-manager.service";
import {Paginator} from "../../models/paginator";
import {Procedure} from "../../models/procedure";

@Component({
  selector: 'app-equipment-page',
  templateUrl: './equipment-page.component.html',
  styleUrls: ['./equipment-page.component.scss']
})
export class EquipmentPageComponent implements OnInit, AfterViewInit {

  isLoading = true;

  equipments: Equipment[] = [];
  equipmentsToShow = [];

  paginator: Paginator<Equipment>;

  constructor(
    public router: Router,
    private equipmentManagerService: EquipmentManagerService,
    private authoringManagerService: AuthoringManagerService,
    private uiManagerService: UiManagerService
  ) { }

  ngOnInit() {
    this.paginator = new Paginator<Equipment>();
  }

  async ngAfterViewInit(): Promise<void> {
    await this.fetchEquipments();
  }

  async fetchEquipments() {

    this.isLoading = true;

    this.paginator.onPageResults = async (equipments: Equipment[]) => {
      this.equipments = equipments;
      this.equipmentsToShow = await Promise.all(this.equipments.map(async equipment => {
        return {
          uid: equipment.id,
          icon: 'widgets',
          name: equipment.name + ' - ' + equipment.manufacturer,
          tot_procedures: (await this.authoringManagerService.getProcedures(equipment.id, new Paginator<Procedure>({ignorePagination: true}))).length, //proceduresMap.find(entry => entry.equipmentUID == equipment.id).procedures.length,
          skills: [
            /*{ text: 'Mantenance', color: this.uiManagerService.getRandomColor() },
            { text: 'Energy', color: this.uiManagerService.getRandomColor() },
            { text: 'Efficency', color: this.uiManagerService.getRandomColor() },*/
          ] as Chip[]
        };
      }));
    }

    // Fetch equipments on start
    await this.equipmentManagerService.getEquipments(this.paginator);

    this.isLoading = false;

  }

  getActions(): CardAction[] {
    return [
      { icon: 'add', name: 'New equipment', callback: () => { this.router.navigate(['equipment/create']) } },
    ];
  }

  /*getTableColumns(): TableColumn[] {
    return [
      { key: 'icon', type: TableColumnType.ICON, title: '' },
      { key: 'name', type: TableColumnType.DEFAULT, title: 'Name' },
      { key: 'tot_procedures', type: TableColumnType.DEFAULT, title: 'Num. of procedures' },
      { key: 'skills', type: TableColumnType.DEFAULT, title: 'Skills' },
      { key: 'created_at', type: TableColumnType.DATE, title: 'Created at' },
      { key: 'manage', type: TableColumnType.ACTIONS, title: 'Manage' },
    ];
  }

  getTableRows() {
    return [
      { icon: 'widgets', name: 'Test', tot_procedures: 22, skills: [], created_at: new Date(), manage: [{ icon: 'open_in_new', callback: () => {} }, { icon: 'delete', callback: () => {}, color: 'warn' }] as TableAction[] },
      { icon: 'widgets', name: 'Test', tot_procedures: 22, skills: [], created_at: new Date(), manage: [{ icon: 'open_in_new', callback: () => {} }, { icon: 'delete', callback: () => {}, color: 'warn' }] as TableAction[] },
      { icon: 'widgets', name: 'Test', tot_procedures: 22, skills: [], created_at: new Date(), manage: [{ icon: 'open_in_new', callback: () => {} }, { icon: 'delete', callback: () => {}, color: 'warn' }] as TableAction[] },
      { icon: 'widgets', name: 'Test', tot_procedures: 22, skills: [], created_at: new Date(), manage: [{ icon: 'open_in_new', callback: () => {} }, { icon: 'delete', callback: () => {}, color: 'warn' }] as TableAction[] },
      { icon: 'widgets', name: 'Test', tot_procedures: 22, skills: [], created_at: new Date(), manage: [{ icon: 'open_in_new', callback: () => {} }, { icon: 'delete', callback: () => {}, color: 'warn' }] as TableAction[] },
      { icon: 'widgets', name: 'Test', tot_procedures: 22, skills: [], created_at: new Date(), manage: [{ icon: 'open_in_new', callback: () => {} }, { icon: 'delete', callback: () => {}, color: 'warn' }] as TableAction[] },
      { icon: 'widgets', name: 'Test', tot_procedures: 22, skills: [], created_at: new Date(), manage: [{ icon: 'open_in_new', callback: () => {} }, { icon: 'delete', callback: () => {}, color: 'warn' }] as TableAction[] },
    ];
  }*/

}
